// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"BookingsList_pageHeader__1TNsC"};